export default function LocationNode() {
    return (
        <div className="mt-2 space-y-2">
            <div className="flex items-center gap-1.5 rounded-md bg-cyan-500/10 border border-cyan-500/30 px-2 py-2 text-[10px] text-cyan-300">
                <i className="fas fa-map-marker-alt text-cyan-400" />
                <span>Envia a localização aproximada do lead (baseada no IP) com offset aleatório de 1-2 km.</span>
            </div>
        </div>
    );
}
